import type { FiatCurrency } from '__generated__/globalTypes';
import { useAmountWithConversion } from 'hooks/useAmountWithConversion';
import { useCurrentUserCurrencies } from 'hooks/useCurrentUserCurrencies';
import { useIsMobileApp } from 'hooks/useIsMobileApp';
import type { MonetaryAmount } from 'lib/monetaryAmount';

const symbolRx: Record<FiatCurrency, RegExp> = {
  EUR: /(^|[0-9]|\s)€($|[0-9]|\s)/,
  USD: /(^|[0-9]|\s)\$($|[0-9]|\s)/,
  GBP: /(^|[0-9]|\s)£($|[0-9]|\s)/,
};

export const useStoreAmount = ({
  monetaryAmount,
  googlePrice,
  applePrice,
}: {
  monetaryAmount: MonetaryAmount;
  googlePrice: string | null | undefined;
  applePrice: MonetaryAmount;
}) => {
  const { isAndroidApp, isIosApp, isMarketAuthorizedIosApp } = useIsMobileApp();
  const { fiatCurrency } = useCurrentUserCurrencies();
  const { main } = useAmountWithConversion({ monetaryAmount });
  const { main: mainApplePrice, exponent: mainAppleExponent } =
    useAmountWithConversion({
      monetaryAmount: applePrice,
    });

  if (isAndroidApp && googlePrice) {
    const samePriceOrSameCurrency =
      main === googlePrice || googlePrice.match(symbolRx[fiatCurrency]);

    const storeMain = samePriceOrSameCurrency ? googlePrice : main;
    const storeExponent = samePriceOrSameCurrency ? undefined : googlePrice;
    return { storeMain, storeExponent };
  }
  if (isIosApp && !isMarketAuthorizedIosApp && applePrice) {
    return { storeMain: mainApplePrice, storeExponent: mainAppleExponent };
  }
  return { storeMain: undefined, storeExponent: undefined };
};
